function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as o } from "react/jsx-runtime";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as r } from "../../skins/skin-contract.css-mistica.js";
const a = (_param)=>{
    var { color: t , size: c = 24  } = _param, e = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const h = s(), i = t !== null && t !== void 0 ? t : h ? r.colors.inverse : r.colors.neutralHigh;
    return /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: /* @__PURE__ */ o("path", {
            fill: i,
            d: "M18.25 5.922v-.708C18.25 3.44 16.85 2 15.126 2H8.874C7.15 2 5.75 3.44 5.75 5.214v13.572C5.75 20.56 7.15 22 8.874 22h6.248c1.724 0 3.124-1.44 3.124-3.214V5.931l.002-.004s.002-.002.002-.005zM8.874 2.713h6.248c1.342 0 2.43 1.12 2.43 2.5v.353H6.443v-.352c0-1.38 1.089-2.5 2.43-2.5zm0 18.57c-1.342 0-2.43-1.12-2.43-2.501v-.357h7.291c.191 0 .347-.16.347-.356a.352.352 0 00-.347-.357H6.443V6.279h11.11v12.503c0 1.38-1.09 2.5-2.431 2.5H8.874zm7.638-3.215a.704.704 0 01-.693.714.704.704 0 01-.693-.713c0-.394.311-.714.693-.714.382 0 .693.32.693.713zm-3.297-2.495c.636 0 1.267-.179 1.822-.508.165-.1.222-.32.125-.489a.343.343 0 00-.476-.128c-.449.27-.96.411-1.475.411-1.329 0-2.449-.905-2.822-2.144h2.995c.191 0 .347-.16.347-.356a.352.352 0 00-.347-.357H10.27c-.004-.06-.009-.119-.009-.178 0-.183.018-.361.05-.535h3.07c.19 0 .346-.16.346-.356a.352.352 0 00-.346-.357h-2.862c.462-1.051 1.489-1.787 2.684-1.787.515 0 1.027.141 1.475.411.165.1.378.041.476-.128a.363.363 0 00-.125-.49 3.541 3.541 0 00-1.822-.507c-1.582 0-2.928 1.047-3.43 2.501H8.87a.352.352 0 00-.346.357c0 .196.155.356.346.356h.738c-.022.174-.04.352-.04.535 0 .06.005.119.009.178h-.702a.352.352 0 00-.347.357c0 .196.156.356.347.356h.804c.391 1.637 1.826 2.858 3.537 2.858z"
        })
    }));
}, m = a;
export { m as default };
